module.exports = __webpack_public_path__ + "img/CapTechTradingContracts.bbb0e4be.webp";